export default __webpack_public_path__ + "static/media/Nunito-SemiBoldItalic.a11f79b3.woff";